module.exports = __webpack_public_path__ + "img/advantage_02.f9235935.png";